module.exports = __webpack_public_path__ + "static/media/magnify.99463ee6.svg";